module.exports = __webpack_public_path__ + "static/3dokay-5d6dec22fa0dc9c4e937d21c6f72ab3b.jpg";